var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-flex',{staticClass:"admin-page"},[_c('admin-mission-plan-template',{attrs:{"itemid":_vm.itemid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }